import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastController: ToastController) { }

  async showSuccess(message: string, position: 'top' | 'bottom' = 'bottom') {
    await this.showToast(message, 'success', position, 'checkmark-circle');
  }

  async showError(message: string, position: 'top' | 'bottom' = 'bottom') {
    await this.showToast(message, 'danger', position, 'alert-circle');
  }

  async showWarning(message: string, position: 'top' | 'bottom' = 'bottom') {
    await this.showToast(message, 'warning', position, 'warning');
  }

  async showInfo(message: string, position: 'top' | 'bottom' = 'bottom') {
    await this.showToast(message, 'info', position, 'information-circle');
  }

  async showConfirm(message: string, onConfirm: () => void, position: 'top' | 'bottom' = 'bottom') {
    this.dismissTop().catch(() => {});
    const opts = {
      message,
      duration: 5000,
      position,
      cssClass: `custom-toast toast-confirm toast-${position}`,
      icon: 'help-circle',
      buttons: [
        { text: 'Oui', handler: onConfirm, role: 'confirm' },
        { text: 'Non', role: 'cancel' }
      ]
    };
    await this.deferPresent(() => this.toastController.create(opts));
  }

  private async dismissTop(): Promise<void> {
    try {
      const existing = await this.toastController.getTop();
      if (existing) await existing.dismiss();
    } catch {
      // ignore
    }
  }

  private deferPresent(create: () => Promise<HTMLIonToastElement>): Promise<void> {
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          const toast = await create();
          await toast.present();
          resolve();
        } catch (e) {
          // Surface any production-only issues in the console
          console.error('Error presenting toast', e);
          reject(e);
        }
      }, 0);
    });
  }

  private async showToast(message: string, type: 'success' | 'danger' | 'warning' | 'info', position: 'top' | 'bottom', icon: string) {
    this.dismissTop().catch(() => {});
    const opts = {
      message,
      duration: 3000,
      position,
      cssClass: `custom-toast toast-${type} toast-${position}`,
      icon,
      buttons: [{ icon: 'close', role: 'cancel' }]
    };
    await this.deferPresent(() => this.toastController.create(opts));
  }
}
